import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { CookieIcon, XIcon } from 'lucide-react';
export function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);
  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setIsVisible(false);
  };
  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setIsVisible(false);
  };
  return <AnimatePresence data-id="element-74">
      {isVisible && <motion.div initial={{
      y: 40,
      opacity: 0,
      scale: 0.95
    }} animate={{
      y: 0,
      opacity: 1,
      scale: 1
    }} exit={{
      y: 40,
      opacity: 0,
      scale: 0.95
    }} transition={{
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1]
    }} className="fixed bottom-6 left-6 right-6 md:left-auto md:right-8 md:bottom-8 md:max-w-md z-50" data-id="element-75">
          <div className="relative bg-[#1a2744]/95 backdrop-blur-xl rounded-2xl p-6 shadow-2xl shadow-black/20 border border-white/10 overflow-hidden" data-id="element-76">
            {/* Decorative gradient accent */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#e91e8c] via-[#5bbcd5] to-[#e91e8c]" data-id="element-77" />

            {/* Close button */}
            <button onClick={handleDecline} className="absolute top-4 right-4 text-white/40 hover:text-white transition-colors" aria-label="Close cookie banner" data-id="element-78">
              <XIcon className="w-4 h-4" data-id="element-79" />
            </button>

            {/* Icon + heading */}
            <div className="flex items-center gap-3 mb-3" data-id="element-80">
              <div className="w-10 h-10 rounded-full bg-[#e91e8c]/15 flex items-center justify-center flex-shrink-0" data-id="element-81">
                <CookieIcon className="w-5 h-5 text-[#e91e8c]" data-id="element-82" />
              </div>
              <h3 className="text-white font-semibold text-base" data-id="element-83">
                We value your privacy
              </h3>
            </div>

            {/* Body text */}
            <p className="text-white/70 text-sm leading-relaxed mb-5" data-id="element-84">
              We use cookies to improve your experience and analyse site
              traffic. Read our{' '}
              <Link to="/privacy-policy" className="text-[#5bbcd5] hover:text-white transition-colors underline underline-offset-2 decoration-[#5bbcd5]/40" data-id="element-85">
                Privacy Policy
              </Link>{' '}
              to learn more.
            </p>

            {/* Buttons */}
            <div className="flex items-center gap-3" data-id="element-86">
              <button onClick={handleAccept} className="flex-1 px-5 py-2.5 rounded-full bg-[#d0187c] text-white font-bold hover:bg-[#b8146d] transition-all duration-200 text-sm tracking-wide" data-id="element-87">
                Accept all
              </button>
              <button onClick={handleDecline} className="flex-1 px-5 py-2.5 rounded-full border border-white/20 text-white/80 font-semibold hover:bg-white/10 hover:text-white transition-all duration-200 text-sm tracking-wide" data-id="element-88">
                Decline
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}